import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CalendarEvent from 'containers/CalendarEvent/CalendarEventContainer';
import classes from './CalendarDay.module.scss';

const CalendarDay = (props) => {
  const { targetDay, dayName, longDate, events, isToday, isTomorrow } = props;

  const dayTitle = () => {
    if (isToday) {
      return (<FormattedMessage
        id="components.calendarDay.today"
        defaultMessage="Today"
      />);
    }

    if (isTomorrow) {
      return (<FormattedMessage
        id="components.calendarDay.tomorrow"
        defaultMessage="Tomorrow"
      />);
    }

    return dayName;
  };

  return (
    <div className={classes.container}>
      <h3 className={classes.dateline}>
        <span>
          {dayTitle()}
        </span>
        <span>
          {longDate}
        </span>
      </h3>
      <div className={classes.eventsContainer}>
        {events.length ? events.map((event, index) => <CalendarEvent event={event} key={index} targetDay={targetDay} />) :
          <div className={classes.emptyDay}>
            <FormattedMessage
              id="components.calendarDay.noMeetings"
              defaultMessage="You have no meetings."
            />
          </div>
        }
      </div>
    </div>
  );
};

CalendarDay.propTypes = {
  dayName: PT.string,
  events: PT.array,
  isToday: PT.bool,
  isTomorrow: PT.bool,
  longDate: PT.string,
  targetDay: PT.object
};

export default CalendarDay;
